module.exports = __webpack_public_path__ + "static/img/coin.654482a6.png";